import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";


export const TrashReadings = createAsyncThunk(
  "bill/TrashReading",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      let response;

      if (id) {
        // 🔵 Tenant side (Update)
        response = await axios.post(
          `${BASE_URL}/update-trash-reading/${id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        // 🟢 Owner side (Create)
        response = await axios.post(
          `${BASE_URL}/trash-reading`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



const TrashReading = createSlice({
    name: "TrashReading",
    initialState: {
        loading: false,
        TrashReading: [],
        error: ""
    },
    extraReducers: {
        [TrashReadings.fulfilled]: (state, action) => {
            state.TrashReading = action.payload;
            state.loading = false;
        },
        [TrashReadings.pending]: (state) => {
            state.loading = true;
        },
        [TrashReadings.rejected]: (state, action) => {
            state.error = action.error.message;
            state.loading = false;
        },
    }
});
export default TrashReading.reducer;

// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import { BASE_URL } from "../../config/config";


// export const TrashReadings = createAsyncThunk(
//   "dummyData/TrashReading",
//   async (formData, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/trash-reading`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Accept: "application/json",
//             // Authorization: "Bearer " + token,
//           },
//         }
//       );
      
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );




// const TrashReading = createSlice({
//   name: "trashReading",
//   initialState: {
//     loading: false,
//     data: null,
//     error: null,
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(TrashReadings.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(TrashReadings.fulfilled, (state, action) => {
//         state.loading = false;
//         state.data = action.payload;
//       })
//       .addCase(TrashReadings.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export default TrashReading.reducer;